import { render, staticRenderFns } from "./DeviceTypeAdd.form.vue?vue&type=template&id=881ecc62&"
import script from "./DeviceTypeAdd.form.vue?vue&type=script&lang=js&"
export * from "./DeviceTypeAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports